import { render, staticRenderFns } from "./CopySubscribe.vue?vue&type=template&id=c9d0b3aa&"
import script from "./CopySubscribe.vue?vue&type=script&lang=js&"
export * from "./CopySubscribe.vue?vue&type=script&lang=js&"
import style0 from "./CopySubscribe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports